Slider =  {

	init : ->
		console.log 'Slider init'

		if not Config.isMobile()
			$('*[slick="desktop-3"]').slick({
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 1,
			})
		else
			$('*[slick="mobile-1"]').slick({
				arrows: false,
				dots: true
			})

		$('*[slick="all-1"]').slick({
			arrows: false,
			dots: true
		})

		@controlsManager()

	
	controlsManager : ->

		eltOpacity = $('.slider-container .control_next .control--nb').css('opacity')

		# Show arrow on hover 
		$('.slider-container .controls-container').on "mouseenter", (ev) ->
			if not $(@).hasClass('active')
				_this = @
				controlNextElt = $(@).find('.control_next')
				
				tlShowArrow = new TimelineLite
				tlShowArrow.addLabel('start')
					.to(controlNextElt.find('.control--nb'), 0.3, {autoAlpha:0, ease:Expo.easeOut}, 'start')
					.to(controlNextElt.find('.control--arrow'), 0.4, {x:'0%', ease:Back.easeOut}, 'start')
					.add ->
						$(_this).addClass('active')

		# Hide arrow on mouse leave
		$('.slider-container .controls-container').on "mouseleave", (ev) ->
			if $(@).hasClass('active')
				_this = @
				controlNextElt = $(@).find('.control_next')

				tlHideArrow = new TimelineLite
				tlHideArrow.to(controlNextElt.find('.control--arrow'), 0.4, {x:'100%', ease:Back.easeIn})
					.to(controlNextElt.find('.control--nb'), 0.3, {autoAlpha:eltOpacity, ease:Expo.easeIn})
					.add ->
						$(_this).removeClass('active')
				
		# Change slide on click
		$('.slider-container .controls-container').on "click", (ev) ->
			
			slider = $(@).parents('.slider-container').find('[slick]')

			# trigger slide change
			slider.slick('slickNext')

			# Update slide number
			sliderNbElt = $(@).parents('.slider-container').find('.control_prev .control--nb')

			currentSlideNb = slider.slick('slickCurrentSlide') + 1

			# Add 0 at the start if currentSlideNb < 10
			if currentSlideNb.toString().length < 2
				currentSlideNb = "0" + currentSlideNb

			tlUpdateSlideNb = new TimelineLite
			tlUpdateSlideNb.addLabel('start')
				.fromTo(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1}, {y:'-100%', autoAlpha:0, rotationX:'-90deg', ease:Back.easeOut})
				.add ->
					sliderNbElt.html(currentSlideNb)
				.set(sliderNbElt, {y:'0%', rotationX:'90deg'})
				.to(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1, rotationX:0, ease:Expo.easeOut})

		# Update slide number on swipe
		$('[slick]').on 'swipe', (event, slick, direction) ->
			
			sliderContainer = slick.$slider.parents('.slider-container')
			sliderNbElt = sliderContainer.find('.control_prev .control--nb')
			currentSlideNb = slick.$slider.slick('slickCurrentSlide') + 1

			# Add 0 at the start if currentSlideNb < 10
			if currentSlideNb.toString().length < 2
				currentSlideNb = "0" + currentSlideNb
			
			tlUpdateSlideNb = new TimelineLite
			tlUpdateSlideNb.addLabel('start')
				.fromTo(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1}, {y:'-100%', autoAlpha:0, rotationX:'-90deg', ease:Back.easeOut})
				.add ->
					sliderNbElt.html(currentSlideNb)
				.set(sliderNbElt, {y:'0%', rotationX:'90deg'})
				.to(sliderNbElt, 0.3, {y:'-50%', autoAlpha:1, rotationX:0, ease:Expo.easeOut})

	destroy : ->
		console.log "Slider destroy"
		
}